'use client'
import {
  minifyGqlQuery
} from "./chunk-SQE4KWHX.mjs";
import {
  QA_QUERY
} from "./chunk-E2IPB3JC.mjs";
import {
  RICHTEXT_QUERY
} from "./chunk-G62SUGCR.mjs";
import {
  TAG_QUERY
} from "./chunk-MWW3YBFP.mjs";
import {
  OTHER_BOOKING_OPTIONS_QUERY
} from "./chunk-6KZWPHJX.mjs";
import {
  LOCATION_QUERY
} from "./chunk-RJD7S7WV.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-5GNKV3HD.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-2QEV6CST.mjs";
import {
  requestWithRateLimitHandling
} from "./chunk-DZ54PK2S.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/restaurants/detail.ts
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var QUERY = gql`
query getRestaurantDetail($lang: String, $limit: Int, $skip: Int, $where: RestaurantFilter, $order: [RestaurantOrder]) {
  restaurantCollection(locale: $lang, limit: $limit, skip: $skip, where: $where, order: $order) {
    total
    items {
      __typename
      sys { id }
      id
      title
      tags
      description{${RICHTEXT_QUERY}}
      logo{${IMAGE_QUERY}}
      about{${QA_QUERY}}
      thingsToKnow{${QA_QUERY}}
      features{${QA_QUERY}}
      attendees{${QA_QUERY}}
      contact{
        title
        description{json}
      }
      menuCollection{
        items{${IMAGE_QUERY}}
      }
      zoneEntryIncluded
      slug
      ticketingUrlSlug
      image11{${IMAGE_QUERY}}
      image31{${IMAGE_QUERY}}
      startingPrice
      currencyCode
      eventType
      buttonLink
      buttonLabel
      cardButtonLabel
      eventType
      authGaurd
      buttonLink
      richTerms { json }
      carousalCollection(limit: 40) {
        items {${IMAGE_QUERY}}
      }
      cmsTagsCollection(limit: 10){
        items {${TAG_QUERY}}
      } 
      location{${LOCATION_QUERY}}
      category{id title slug}
      season{title slug}
      zone{
        id title slug zoneLogo{${IMAGE_QUERY}} sponsorLogo{${IMAGE_QUERY}}
      }
      isComingSoon
      specialPromotion
      schedule{${SCHEDULE_QUERY}}
      otherBookingSection {${OTHER_BOOKING_OPTIONS_QUERY}}
      visibility
    }
  }
}
`;
var getRestaurantDetail = (props) => __async(void 0, null, function* () {
  var _a, _b, _c;
  try {
    const res = yield requestWithRateLimitHandling(minifyGqlQuery(QUERY), __spreadProps(__spreadValues({
      order: "order_ASC"
    }, props), {
      lang: getContentfulSafeLocale(props.lang)
    }));
    return {
      data: (_b = (_a = res.restaurantCollection) == null ? void 0 : _a.items) == null ? void 0 : _b[0],
      rateLimited: (_c = res.rateLimited) != null ? _c : false
    };
  } catch (error) {
    throw new Exception({ error, name: "getRestaurantDetailException" });
  }
});
var useGetRestaurantDetail = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getRestaurantDetail", props],
    queryFn: () => getRestaurantDetail(props)
  }, options));
};

export {
  getRestaurantDetail,
  useGetRestaurantDetail
};
//# sourceMappingURL=chunk-6TZSBAQF.mjs.map